import JSBI from "jsbi";
import { bufferLeToBeHex, bufferToPrettyHex } from "./hexUtils";
import { interpretAsSignedType, interpretAsTwosComplement } from "./intUtils";

// 从Uint8Array读取32位浮点数
function readFloatLE(bytes, offset = 0) {
  const view = new DataView(bytes.buffer, bytes.byteOffset + offset, 4);
  return view.getFloat32(0, true); // true for little-endian
}

// 从Uint8Array读取32位有符号整数
function readInt32LE(bytes, offset = 0) {
  const view = new DataView(bytes.buffer, bytes.byteOffset + offset, 4);
  return view.getInt32(0, true); // true for little-endian
}

// 从Uint8Array读取32位无符号整数
function readUInt32LE(bytes, offset = 0) {
  const view = new DataView(bytes.buffer, bytes.byteOffset + offset, 4);
  return view.getUint32(0, true); // true for little-endian
}

// 从Uint8Array读取64位浮点数
function readDoubleLE(bytes, offset = 0) {
  const view = new DataView(bytes.buffer, bytes.byteOffset + offset, 8);
  return view.getFloat64(0, true); // true for little-endian
}

export function decodeFixed32(value) {
  const floatValue = readFloatLE(value, 0);
  const intValue = readInt32LE(value, 0);
  const uintValue = readUInt32LE(value, 0);

  const result = [];

  result.push({ type: "int", value: intValue });

  if (intValue !== uintValue) {
    result.push({ type: "uint", value: uintValue });
  }

  result.push({ type: "float", value: floatValue });

  return result;
}

export function decodeFixed64(value) {
  const floatValue = readDoubleLE(value, 0);
  const uintValue = JSBI.BigInt("0x" + bufferLeToBeHex(value));
  const intValue = interpretAsTwosComplement(uintValue, 64);

  const result = [];

  result.push({ type: "int", value: intValue.toString() });

  if (intValue !== uintValue) {
    result.push({ type: "uint", value: uintValue.toString() });
  }

  result.push({ type: "double", value: floatValue });

  return result;
}

export function decodeVarintParts(value) {
  const result = [];
  const uintVal = JSBI.BigInt(value);
  result.push({ type: "uint", value: uintVal.toString() });

  for (const bits of [8, 16, 32, 64]) {
    const intVal = interpretAsTwosComplement(uintVal, bits);
    if (intVal !== uintVal) {
      result.push({ type: "int" + bits, value: intVal.toString() });
    }
  }

  const signedIntVal = interpretAsSignedType(uintVal);
  if (signedIntVal !== uintVal) {
    result.push({ type: "sint", value: signedIntVal.toString() });
  }

  return result;
}

export function decodeStringOrBytes(value) {
  if (!value.length) {
    return { type: "string|bytes", value: "" };
  }
  
  // 尝试解码为字符串
  const td = new TextDecoder("utf-8", { fatal: false });
  const stringValue = td.decode(value);
  
  // 检查是否为有效的可读字符串
  const isReadableString = stringValue.length > 0 && 
                          /^[\x20-\x7E]*$/.test(stringValue) &&
                          stringValue.length <= 1000; // 限制长度避免显示过长的字符串
  
  if (isReadableString) {
    return { type: "string", value: stringValue };
  } else {
    // 如果无法解析为可读字符串，返回hex格式
    return { type: "string|bytes", value: bufferToPrettyHex(value) };
  }
}
